module.exports = __webpack_public_path__ + "static/media/robot-green-1.fb4e5b00.svg";